import { CHARACTER_TYPES } from './../../../f.assets/Characters/scripts/constants';
import { RootState } from '@react-three/fiber'
import { Object3D, Vector2 } from 'three'
import { useSceneStore } from '../../../a.scenes/GameScene/store'
import { CharacterBaseState } from '../../../c.managers/CharactersManager/types'
import { Characters } from '../../../d.controllers/CharactersController'
import { GameObject3D, GAME_OBJECTS } from './types'

export default class GameObject {
  types: GAME_OBJECTS[]
  obj: GameObject3D

  constructor(obj: Object3D) {
    this.obj = obj as GameObject3D
    this.obj.__gameObject = this
    this.types = [GAME_OBJECTS.OBJECT]
  }

  // setThreeObject(obj: Object3D) {
  // }
  onStart() {}
  onUpdate(state?: RootState, delta?: number, frame?: any) {}
  onUnload() {}

  isClass(className: GAME_OBJECTS) {
    return this.types.includes(className)
  }

  // custom methods for this game
  get uuid() {
    return this.obj.uuid
  }
  get coords() {
    return this.obj.userData.coords as Vector2
  }
}
